// extracted by mini-css-extract-plugin
export default {"clockNumber":"Clock_clockNumber__sfy5A","clockDiv":"Clock_clockDiv__5sMZp"};